export const APP_NAME = "lever";

export function LeverMark({ size = 18, className }: { size?: number; className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 221 226"
      fill="currentColor"
      className={className}
    >
      <path d="M187.4 4.17 4.2 186.77l28.97 30.6 82.73-82.68c-9.12 10.84-12.18 23.18-11.16 37.43 2.34 28.63 28 50.11 56.6 50.11 29.63 0 51.34-25.37 51.34-53.62 0-29.02-23.91-54.33-54.03-54.33-13.15 0-24.15 4.34-34.14 11.72l93.37-91.72L187.4 4.22z" />
    </svg>
  );
}

export const appNameClassName = "font-semibold tracking-[0.01em]";
export const appNameStyle = { fontFamily: "var(--font-display)" } as const;
